import { dateConstants } from '@utils/constants';
import { dateUtils } from '@utils';
import dateFilter from '@/utils/date';
import dateShortFormat from '@/utils/dateShortFormat';

export function ordersStatisticsAggregateDate(date, level) {
    switch (level) {
        case 'day':
            return dateShortFormat(dateUtils.getDateStringWithoutUTC(date));
        case 'month':
            return dateFilter(
                dateUtils.getDateStringWithoutUTC(date),
                dateConstants.FORMAT.UI_DATE_MONTH_YEAR
            );
        default:
            break;
    }
}
